import { Modal, Space, Table, Typography } from 'antd';
import Column from 'antd/es/table/Column';
import { Link, useParams } from 'react-router-dom';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { IResource } from '../hooks/useResources';
import PaginationGeneric from './PaginationGeneric';
import usePermissions from 'hooks/usePermissions';

const { Text } = Typography;
export default (props: {
  resources: any;
  total: number;
  loading: boolean;
  error: any;
  onPageChange?: (val: number, pageSize: number) => void;
  onDelete: (resource: IResource) => Promise<any>;
}) => {
  const { onPageChange, error } = props;
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [deleteModalLoading, setDeleteModalLoading] = useState(false);
  const [deleteResource, setDeleteResource] = useState<IResource>({
    allowedRoleIds: [],
    code: '',
    description: '',
    parentResourceId: '',
    name: '',
    id: '',
  });

  const { applicationId } = useParams();
  const { checkPermissions } = usePermissions();

  useEffect(() => {
    if (error?.status === 428) {
      setDeleteModalLoading(false);
      setVisibleDeleteModal(false);
    }
  }, [error]);

  const handleOk = () => {
    setDeleteModalLoading(true);
    props.onDelete(deleteResource).then(() => {
      setDeleteModalLoading(false);
      setVisibleDeleteModal(false);
    });
  };

  const deleteResourceModal = (resource: any) => {
    setDeleteResource(resource);
    setVisibleDeleteModal(true);
  };

  const editCta = (resource: any) => {
    return (
      checkPermissions(applicationId, 'resources:update') && (
        <Link to={`${resource.id}/edit`}>
          <EditOutlined style={{ fontSize: '18px' }} title='edit' />
        </Link>
      )
    );
  };

  const deleteCta = (resource: any) => {
    return (
      checkPermissions(applicationId, 'resources:delete') && (
        <DeleteOutlined
          style={{ fontSize: '18px', color: 'red' }}
          title='delete'
          onClick={() => deleteResourceModal(resource)}
        />
      )
    );
  };

  const renderActions = (resource: any) => (
    <Space size='middle'>
      {editCta(resource) || deleteCta(resource) ? (
        <>
          {editCta(resource)} {deleteCta(resource)}
        </>
      ) : (
        '-'
      )}
    </Space>
  );

  const renderParentResource = (resource: any) => {
    if (!resource?.parentResource?.id) return '';
    return <Link to={resource.parentResource.id || ''}>{resource.parentResource.name || ''}</Link>;
  };

  const pageChange = (val: number, pageSize: number) => {
    if (typeof onPageChange === 'function') onPageChange(val, pageSize);
  };

  return (
    <>
      <Table rowKey='id' dataSource={props.resources} pagination={false} loading={props.loading}>
        <Column title='Name' render={({ id, name }) => <Link to={id}>{name}</Link>} />
        <Column title='Parent Resource' render={renderParentResource} />
        <Column title='Actions' key='resource-table-col-actions' align='center' render={renderActions} />
      </Table>

      <PaginationGeneric
        total={props.total}
        hideOnSinglePage={true}
        showSizeChanger={true}
        onPageChange={(page, pageSize) => {
          pageChange(page, pageSize);
        }}
      ></PaginationGeneric>

      <Modal
        title='Alert'
        visible={visibleDeleteModal}
        onOk={handleOk}
        centered
        okButtonProps={{ danger: true, disabled: deleteModalLoading }}
        okText={deleteModalLoading ? 'Removing' : 'Remove'}
        cancelButtonProps={{ disabled: deleteModalLoading }}
        confirmLoading={deleteModalLoading}
        onCancel={() => setVisibleDeleteModal(false)}
      >
        <p>
          Do you want to remove the assignment<Text code>{deleteResource.name || ''}</Text>?
        </p>
      </Modal>
    </>
  );
};
